<template>
    <div v-if="displayMobileAppBanner" class="mobile-app-banner">
        <CompassIconButton
            icon="close"
            size="small"
            class="mobile-app-banner__close"
            @click="displayMobileAppBanner = false"
        />

        <CompassObject
            :label="$t.__('mobileApp.mobileAppBanner.app_name')"
            :caption="$t.__('mobileApp.mobileAppBanner.app_short_description')"
            object="logo"
            size="large"
            class="mobile-app-banner__app"
        />

        <CompassButton
            :label="$t.__('mobileApp.mobileAppBanner.app_download')"
            class="mobile-app-banner__button"
            @click="goToStore"
        />
    </div>
</template>

<script>
import { isiOS, isAndroid, isSafari } from 'Helpers/userAgentHelper';
export default {
    data() {
        return {
            displayMobileAppBanner: false,
        };
    },
    computed: {
        storeLink() {
            if (isiOS()) {
                switch (window.App.locale.split('.')[0]) {
                    case 'en_US':
                        return 'https://apps.apple.com/us/app/sellsy-crm/id1532040961';
                    case 'ca_ES':
                    case 'es_ES':
                        return 'https://apps.apple.com/es/app/sellsy-crm/id1532040961';
                    case 'fr_FR':
                    default:
                        return 'https://apps.apple.com/fr/app/sellsy-crm/id1532040961';
                }
            } else if (isAndroid()) {
                return 'https://play.google.com/store/apps/details?id=com.easybill.sellsyapp';
            }

            return '';
        },
    },
    beforeMount() {
        const currentLocation = window.location.href;
        const excludedPaths = ['/onboarding/trial', '/onboarding/quicktrial'];

        if (
            !excludedPaths.some((excludedPath) => currentLocation.includes(excludedPath)) &&
            ((isiOS() && !isSafari()) || isAndroid())
        ) {
            this.displayMobileAppBanner = true;
        }
    },
    methods: {
        goToStore() {
            window.location.href = this.storeLink;
        },
    },
};
</script>

<style lang="scss" scoped>
.mobile-app-banner {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1000;
    max-width: 100vw;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 10px;
    padding: var(--spacing-2) var(--spacing-3) var(--spacing-2) var(--spacing-1);
    background-color: var(--colors-common-background-default);
    border-bottom: 0.5px solid var(--colors-common-border-lighter);

    &__app {
        gap: 10px;
        :deep() {
            .compass-object__icon {
                height: 56px;
                width: 56px;
                border-radius: 15px;
            }

            .compass-object__label {
                font-size: 16px;
                line-height: var(--line-heights-24);
            }

            .compass-object__caption {
                font-size: var(--font-size-12);
                line-height: var(--line-heights-16);
            }
        }
    }

    &__button {
        margin-left: auto;
        border-radius: var(--spacing-4);
    }
}
</style>

<style lang="scss">
#sellsy_app:has(.mobile-app-banner) {
    #contentDiv.has-sidebar-closed {
        padding-top: 173px !important;
    }

    .navbar {
        top: 81px;
    }

    #menu {
        top: 141px;
    }
}
</style>
